import { apiCall } from './api-call';

const subscribeButton = document.getElementById('js-newsletter-subscribe-btn');
const successMessage = document.getElementsByClassName(
  'js-newsletter-success'
)[0];
const errorMessage = document.getElementsByClassName('js-newsletter-error')[0];

subscribeButton &&
  subscribeButton.addEventListener('click', event => {
    event.preventDefault();
    const payload = JSON.stringify({ user: { juul_newsletter: '1' } });

    apiCall('/api/v1/profile', 'PUT', payload)
      .done(() => {
        subscribeButton.classList.add('hide');
        successMessage.classList.remove('hide');
      })
      .fail(() => {
        errorMessage.classList.remove('hide');
      });
  });



// WEBPACK FOOTER //
// ./app/javascript/apps/application/newsletterForm.js